import { UseMutationResult } from "@tanstack/react-query";
import { useRouter } from "next/router";
import { UseFormReturn } from "react-hook-form";

import { useTranslation } from "../../core/translation.core";
import useShop from "../../hooks/useShop.hook";
import { AttributeFormData } from "../../types/attribute";
import { LocalInputDefaultLocale } from "../locale/locale.comp";
import { EditorSection, SubmitPanel, Title } from "../reuseables/editor.comp";
import { LabelAndInput } from "../reuseables/form.comp";
import { selectCss } from "../reuseables/native.comp";

export default function AttributeEditor({
  methods,
  mutation,
  btnName,
}: {
  methods: UseFormReturn<AttributeFormData, any>;
  mutation: UseMutationResult<void, unknown, AttributeFormData, unknown>;
  btnName: string;
}) {
  const { t, msg } = useTranslation();
  const selectedShop = useShop();
  const { push } = useRouter();

  async function onSubmit(data: AttributeFormData) {
    mutation.mutate(data);
  }

  if (!selectedShop) return null;

  return (
    <form onSubmit={methods.handleSubmit(onSubmit)} className="pb-20">
      <EditorSection>
        <Title>{t(msg.product.generalInfo)}</Title>
        <div className="flex flex-col gap-4">
          <LabelAndInput register={methods.register} fieldName="code" label={t(msg.category.code)} topLabelCss="block" />
          <LocalInputDefaultLocale register={methods.register} label={t(msg.attribute.name)} fieldName="name" />

          <label>
            <span className="block text-xs font-semibold mb-2">{t(msg.attribute.type)}</span>
            <select className={selectCss} {...methods.register("type")}>
              <option value="string">{t(msg.attribute.text)}</option>
              <option value="number">{t(msg.attribute.number)}</option>
            </select>
          </label>

          <LocalInputDefaultLocale register={methods.register} label={t(msg.attribute.unit)} fieldName="unit" />

          <label>
            <span className="block text-xs font-semibold mb-2">{t(msg.attribute.display)}</span>
            <select className={selectCss} {...methods.register("display")}>
              <option value="all">{t(msg.attribute.typeAll)}</option>
              <option value="none">{t(msg.attribute.typeNone)}</option>
            </select>
          </label>
        </div>
      </EditorSection>
      <SubmitPanel>
        <button onClick={() => push("/products")}>{t(msg.form.cancel)}</button>
        <input type="submit" value={btnName} />
      </SubmitPanel>
    </form>
  );
}
